import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Text, RichContent, Button } from '../elements';
import WistiaVideoPlayer from '../../../../components/common/media/WistiaVideoPlayer';
import BackButton from '../../../common/elements/BackButton';

export const TextMediaComponent = props => {
	const { content } = props;

	const url = `https://fast.wistia.net/embed/iframe/${props.content.video}?videoFoam=true`;
	return (
		<section className="col-12 kiwi-media">
			<div className="container">
				<div className="row">
					<div className="col-12">
						<BackButton />
					</div>
					<div className="media">
						{(content.heading || content.descriptionRich || content.button) && (
							<div className="media__content">
								<div className="media-back-btn"></div>
								<br />
								{content.heading && (
									<Heading size="h2" content={content.heading} />
								)}
								{content.descriptionRich && (
									<div className="media__content--description">
										<RichContent dangerous={content.descriptionRich} />
									</div>
								)}
								{content.button && (
									<Button
										label={content.button.label}
										link={content.button.link}
										color={content.button.color}
										textColor={content.button.textColor}
									/>
								)}
							</div>
						)}
						{(content.video || content.image) && (
							<div className="media__media">
								{content.video && <WistiaVideoPlayer url={url} />}
								{content.image && (
									<img src={content.image} alt="TextMediaComponent" />
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

TextMediaComponent.propTypes = {
	content: PropTypes.object,
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/TextMediaComponent.js